export enum FinishStatus {
    notStart,
    studying,
    finished
}
export const FinishStatusText = {
    [FinishStatus.notStart]: "未开始",
    [FinishStatus.studying]: "学习中",
    [FinishStatus.finished]: "已完成"
};
export enum SimulationType {
    homePage,
    loadingPage,
    modelBrowsing,
    componentIntroduction,
    auxiliaryPositioning,
    twoDimensionalAndThreeDimensionalComparison,
    exercises
}
export const SimulationTypeText = {
    [SimulationType.homePage]: "主页",
    [SimulationType.loadingPage]: "加载页",
    [SimulationType.modelBrowsing]: "模型浏览",
    [SimulationType.componentIntroduction]: "构件介绍",
    [SimulationType.auxiliaryPositioning]: "辅助定位",
    [SimulationType.twoDimensionalAndThreeDimensionalComparison]: "二维三维对照",
    [SimulationType.exercises]: "练习题"
};
export const SimulationTypeEnglishText = {
    [SimulationType.modelBrowsing]: "MODEL BROWSING",
    [SimulationType.componentIntroduction]: "COMPONENT INTRODUCTION",
    [SimulationType.auxiliaryPositioning]: "AUXILIARY POSITIONING",
    [SimulationType.twoDimensionalAndThreeDimensionalComparison]: "TWO DIMENSIONAL AND THREE DIMENSIONAL COMPARISON",
    [SimulationType.exercises]: "EXERCISES"
};
export const ImageExtension = ['JPG', 'PNG'];
export const VideoExtension = [
  'MP4',
];
export const FileExtension = [
  'DOC', 'DOCX', 'PPT', 'XLS',
];
